import NamedDto from 'modules/base/dto/NamedDto';
import DriverType from './DriverType';

export default class DriverEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {DriverType} */
		this.type = null;
		/** @type {number} */
		this.driverLog = null;
	}

	/**
	 * @typedef {Object} _DriverEditDtoProps
	 * @property {DriverType} type
	 * @property {number} driverLog
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _DriverEditDtoProps} DriverEditDtoProps
	 */
	/**
	 *
	 * @param {DriverEditDtoProps} props
	 * @returns {DriverEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.driverLog = props.driverLog;

		return this;
	}
}
